/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgPaginationArrowLeft as PaginationArrowLeftMedium } from "./medium/PaginationArrowLeft";
const sizeMap = {
    medium: PaginationArrowLeftMedium,
};
const defaultSize = getDefaultSize(sizeMap);

export const PaginationArrowLeftIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
PaginationArrowLeftIcon.displayName = "PaginationArrowLeftIcon";
